import { Injectable, OnInit } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ClickjackingPreventionService implements OnInit {

  constructor() {}

  ngOnInit(): void {
    this.preventClickjacking();
  }

  preventClickjacking(): void {
    if (window.top !== window.self) {
      // Redirect to a safe URL or show a message
      window!.top!.location.href = '/';
    }
  }
}
